export default __webpack_public_path__ + "static/media/transfacil_galery_17.b709794c.jpg";